import React from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import "../../../assets/css/stripe.css";
import { CheackOutForm } from "../../UIkit";

// Make sure to call loadStripe outside of a component’s render to avoid
// recreating the Stripe object on every render.
// loadStripe is initialized with your real test publishable API key.
const promise = loadStripe(
  "pk_test_51IsKsuKSlIImOvRf2bQwEE4nGMO7MqEmLaVztpbH78eDwKTC84akt2XPCQO263BE9M5t6t75s6rQVEn6f2QKMPjr00rmRPN9xh"
);

const StripeBox = () => {
  return (
    <div className="App">
      <Elements stripe={promise}>
        <CheackOutForm />
      </Elements>
    </div>
  );
};

export default StripeBox;
